var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MainSlider',{attrs:{"slides-data":_vm.slidesData,"additional-settings":_vm.additionalSettings,"user-region":_vm.userRegion,"disable-video-in-banners":_vm.disableVideoInBanners,"is-mobile":_vm.$isMobile}})
}
var staticRenderFns = []

export { render, staticRenderFns }